import Config from "Config";
import axiosCalls from "global/util/axiosCalls";
import RnsSearchResultDTO from "./dto/RnsSearchResultDTO";
import RnsGln from "./interface/RnsGln";
import RnsHistory from "./interface/RnsHistory";
import SearchQueryOptions from "./interface/SearchQueryOptions";

const RnsService = {
  searchRNS: (
    searchQuery: SearchQueryOptions,
    callbackOnSuccess: Function,
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendGet(Config.dataServiceUrl + "rns/search", {
        params: {
          rnsGln: searchQuery.gln,
          oldrnsgln: searchQuery.oldGln,
          callSource: searchQuery.callSource,
        },
      })
      .then((response) => {
        callbackOnSuccess(
          RnsSearchResultDTO.convertResponseToRnsSearchResultDTO(response)
        );
      })
      .catch((error) => {
        if (callbackOnFail) callbackOnFail(error);
      });
  },
  updateContactOfGLN: (
    gln: RnsGln,
    callbackOnSuccess?: Function,
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendJsonDataPost(Config.dataServiceUrl + "rns/update", gln)
      .then((response) => {
        if (callbackOnSuccess) callbackOnSuccess(response.data);
      })
      .catch((error) => {
        if (callbackOnFail) callbackOnFail(error);
      });
  },
  searchRNSHistory: (
    automatKey: string,
    callbackOnSuccess: (response: Array<RnsHistory>) => void,
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendGet(
        Config.dataServiceUrl + "rns/search/rns-history/" + automatKey + "/"
      )
      .then((response) => {
        callbackOnSuccess(
          RnsSearchResultDTO.convertResponseToRnsSearchHistoryDTO(response)
        );
      })
      .catch((error) => {
        if (callbackOnFail) callbackOnFail(error);
        // @TODO fire error message
      });
  },
};

export default RnsService;
